export default __webpack_public_path__ + "static/media/Alfajor-dulce-de-leche-y-coco.eaa1750e.jpg";